/* prettier-ignore */
export const content = {
  'designer.reviews.canceledRemotely.title': 'Review canceled',
  'designer.reviews.canceledRemotely.description':
    'This review has been canceled by {{name}}. You will now return to the main view.',
  'designer.reviews.canceledRemotely.continue': 'Continue',
  'designer.reviews.requestedRemotely.title':
    'Review request already submitted',
  'designer.reviews.requestedRemotely.description':
    'A review request has been submitted by {{name}}. Only one review request can be active at a time, so this request will be closed.',
  'designer.reviews.requestedRemotely.continue': 'Continue',
} as const;
